import React from 'react';
import { shape, bool, string } from 'prop-types';
import classNames from 'classnames';

import { IconError } from '../../components/Icons';

import css from './ValidationError.css';

/**
 * This component can be used to show validation errors next to form
 * input fields. The component takes the final-form Field component
 * `meta` object as a prop and infers if an error message should be
 * shown.
 */
const ValidationError = props => {
  const { rootClassName, className, fieldMeta } = props;
  const { touched, error } = fieldMeta;
  const classes = classNames(rootClassName || css.root, className);

  return touched && error ? (
    <div className={classes}>
      <IconError className={css.iconError} />
      <span className={css.errorText}>{error}</span>
    </div>
  ) : null;
};

ValidationError.defaultProps = {
  rootClassName: null,
  className: null,
};

ValidationError.propTypes = {
  rootClassName: string,
  className: string,
  fieldMeta: shape({
    touched: bool.isRequired,
    error: string,
  }).isRequired,
};

export default ValidationError;
